/* eslint-disable no-nested-ternary */
import { Handle } from 'react-flow-renderer';

const DefaultCustomNode = ({ data }) => {
    const customNodeStyles = {
        background: '#F2F2F2 ',
        color: '#222',
        padding: '10px',
        width: 'fit-content',
        fontSize: '12px',
        fontWeight: 'bold',
        textAlign: 'center',
        cursor: 'pointer',
        border: 'none',
        marginTop: '0.1rem',
    };

    const getClassName = label => {
        let className;
        switch (label) {
            case 'Join':
            case 'Sum':
            case 'Min':
            case 'Max':
            case 'Append':
                className = `appkiticon
                icon-link-fill`;
                break;
            default:
                className = '';
                break;
        }

        return className;
    };

    return (
        <>
            <div style={customNodeStyles}>
                <Handle type="source" position="bottom" style={{ background: '#EB8C00' }} />
                <Handle type="target" position="top" style={{ background: '#EB8C00' }} />
                { data.status === 'Exception' && (
                    <span className="appkiticon icon-close-fill" style={{ fontSize: '1rem', color: '#C52A1A', marginRight: '1rem' }} />
                )}
                { data.status === 'Success' && (
                    <span className="appkiticon icon-check-mark-fill" style={{ fontSize: '1rem', color: '#22992E', marginRight: '1rem' }} />
                )}
                <span
                    className={getClassName(data.label)}
                    style={{ fontSize: '2rem' }}
                />
            </div>
            <div style={{ marginBottom: '0.1rem' }}>
                {data.label}
            </div>
        </>
    );
};

export default DefaultCustomNode;
